<template>
    <div class="skeleton">
        <div class="skeleton-line" v-for="n in lineCount" :key="n"></div>
    </div>
</template>

<script>
export default {
    name: "BaseSkeleton",
    props: {
        lineCount: {
            type: Number,
            default: 4
        }
    }
}
</script>

<style scoped lang="scss">
.skeleton {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 1rem 0;
}

.skeleton-line {
    height: 16px;
    background: linear-gradient(90deg, #e0e0e0 25%, #f6f6f6 50%, #e0e0e0 75%);
    background-size: 200% 100%;
    animation: skeleton-loading 1.5s infinite;
    border-radius: 8px;
}

.skeleton-line:nth-child(1) {
    width: 100%;
    height: 40px;
}
.skeleton-line:nth-child(2) {
    width: 100%;
    height: 40px;
}
.skeleton-line:nth-child(3) {
    width: 100%;
    height: 40px;
}
.skeleton-line:nth-child(4) {
    width: 60%;
    height: 40px;
}

@keyframes skeleton-loading {
    0% {
        background-position: 200% 0;
    }
    100% {
        background-position: -200% 0;
    }
}
</style>
